(function () {
  if (getCookie("external_store_redirect") == "rejected") {
    return;
  }
  const externalStoreData = theme.shop.external_stores;
  externalStoreData &&
    window.geoip2 &&
    window.geoip2.country(async (location) => {
      const language = String(navigator.language).substring(0, 2).toLowerCase();
      const countryCode = location.country.iso_code;
      const countryName =
        location.country.names[language] || location.country.names["en"];

      if (
        externalStoreData &&
        externalStoreData.store_url &&
        externalStoreData.store_url[countryCode]
      ) {
        const foundTranslation =
          externalStoreData.locales[language] ||
          externalStoreData.locales["en"];
        const resText = await apiFetchText(
          "",
          `?section_id=external-store-suggestion-modal`
        );
        const modal = document.createElement("div");
        modal.innerHTML = resText;
        document.body.appendChild(modal);
        const redirect_btn = document.querySelector(".redirect__btn");
        const close_btn = document.getElementById("ModalClose-external-store");
        const redirect_title = document.querySelector(".redirect__title");
        const redirect_message = document.querySelector(
          ".redirect__description"
        );
        redirect_title.innerHTML = foundTranslation.redirect_modal_title;
        redirect_btn.href = externalStoreData.store_url[countryCode];
        redirect_btn.innerHTML = foundTranslation.redirect_modal_cta_text;
        redirect_message.innerHTML =
          foundTranslation.redirect_modal_international_store +
          "<br>" +
          foundTranslation.redirect_modal_store;
        const country_name = Array.from(
          document.querySelectorAll(".country_name")
        );
        country_name.forEach((country) => {
          country.innerHTML = countryName;
        });
        close_btn.addEventListener("click", () => {
          setCookie("external_store_redirect", "rejected", 1);
        });
      }
    });
})();
